import { render, staticRenderFns } from "./1to50.vue?vue&type=template&id=403ad0a0&scoped=true&"
import script from "./1to50.vue?vue&type=script&lang=js&"
export * from "./1to50.vue?vue&type=script&lang=js&"
import style0 from "./1to50.vue?vue&type=style&index=0&id=403ad0a0&lang=css&scoped=true&"
import style1 from "./1to50.vue?vue&type=style&index=1&id=403ad0a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403ad0a0",
  null
  
)

export default component.exports